// extracted by mini-css-extract-plugin
export default {"spinner":"PunchupSpinner_spinner__jUKm0","punchupSpinnerRotate":"PunchupSpinner_punchupSpinnerRotate__VenuY"};